$(document).ready(function () {
  //获取推荐人工号
  var workNumber = getUrlParameter('workNumber');
  if (workNumber) {
    if (workNumber.startsWith('ats')) {
      workNumber = workNumber.substring(3); //截取ats
    }
    sessionStorage.setItem('workNumber', workNumber);
  }

  // 获取 URL 参数的函数
  function getUrlParameter(name) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    var results = regex.exec(window.location.href);

    if (!results) return null;
    if (!results[2]) return "";

    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
});
